import { Root as OriginalRoot, type RootProps } from 'react-day-picker';

// Root is dropping some data-attributes and SCSS vars when we apply a root style. Defining our own Root component seems to add them back.
export default function Root({ children, ...props }: RootProps) {
  return <OriginalRoot {...props}>{children}</OriginalRoot>;
}
